import type { ReactElement } from "react";
import { FontWeight } from "@/theme/typography";
import { getRadiusCssValue } from "@/theme/radius";
import { pxToRem } from "@/theme/spacing";
import { CmarkdownLabelText } from "../Cmarkdowntext/CmarkdownLabelText";
import { BADGE_LABEL, type BadgeMetadataEntry } from "./kanban-selectors";
import { METADATA_BADGE_BACKGROUND } from "./kanban-view-constants";
interface KanbanCardBadgeListProps {
    cardKey: string;
    metadataBadges: BadgeMetadataEntry[];
}
export function KanbanCardBadgeList({ cardKey, metadataBadges, }: KanbanCardBadgeListProps): ReactElement | null {
    if (metadataBadges.length === 0) {
        return null;
    }
    return (
      <div style={{
            display: "flex",
            flexWrap: "wrap",
            gap: pxToRem(6),
        }}>
        {metadataBadges.map((entry) => (<div key={`${cardKey}-${entry.key}`} style={{
                display: "inline-flex",
                alignItems: "center",
                borderRadius: getRadiusCssValue(999),
                padding: `${pxToRem(2)} ${pxToRem(8)}`,
                backgroundColor: METADATA_BADGE_BACKGROUND,
            }}>
            <CmarkdownLabelText dataElScope="Cmarkdownkanban/KanbanCardBadgeList" content={`${BADGE_LABEL[entry.key]}: ${entry.value}`} size={11} weight={FontWeight.Medium} paragraphStyle={{ marginBottom: 0 }} textStyle={{
                color: "rgba(255, 255, 255, 0.62)",
                lineHeight: 1.45,
                whiteSpace: "nowrap",
            }}/>
          </div>))}
      </div>
    );
}
